import { ImageTaggedTextProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/utils/TaggedText/ImageTaggedTextProperties";
import { GameMessageBarProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameMessageBarProperties";
import { GameFontStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameFontStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Locale } from "@lib/titan2/dist/game/manager/LanguageManager";
import { Point } from "pixi.js";
/**
 * MessageBarPortraitProperties.ts
 */
export class MessageBarPortraitProperties extends GameMessageBarProperties {
    constructor() {
        super();
        this.messageFieldProperties = new YouCouldWinTaggedTextPortraitProperties();
        this.messageInterval = 3000;
        this.maxLength = new Map([
            [Locale.ENGLISH, 36]
        ]);
        this.position.set(512, 6);
    }
}
export class YouCouldWinTaggedTextPortraitProperties extends ImageTaggedTextProperties {
    constructor() {
        super();
        this.textFieldProperties = new TextFieldProperties(GameFontStyle.GAME_MESSAGES, undefined, undefined, ControlConstants.LEFT, undefined);
        this.size = new Point(750, 60);
        this.position.set(0, -6);
        this.textFieldProperties.autoResize = false;
    }
}
//# sourceMappingURL=MessageBarPortraitProperties.js.map